export default __webpack_public_path__ + "static/media/pix-logo.61bb16db.svg";